var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBranch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19.25V10.8125M7.9 18.7812L10.75 15.5H20.2376L23.1 18.7812M8.85 8H22.15V10.8125H8.85V8ZM6 19.25H9.8V23H6V19.25ZM13.6 19.25H17.4V23H13.6V19.25ZM21.2 19.25H25V23H21.2V19.25Z",
    stroke: "#4A5568",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranch);
export default __webpack_public_path__ + "static/media/branch.3188b6ace765b16466c59a4bc73117e4.svg";
export { ForwardRef as ReactComponent };